<div>
    <div style="margin-left: 5%; margin-right: 5%; margin-bottom: 1%; margin-top: 7px;">
        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">

            <!-- Left-aligned buttons -->
            <div style="display: flex; gap: 10px;">
                <button mat-raised-button color="success" (click)="toggleMethod();" *ngIf="isFirstVisible">
                    ->
                </button>
                <button mat-raised-button color="primary" (click)="saveSubscriptionBarcodesDataEntry();"
                    *ngIf="isFirstVisible">
                    save
                </button>
                <button mat-raised-button color="warning" (click)="toggleMethod()" *ngIf="!isFirstVisible">
                    <- </button>

                        <button [useExistingCss]="true" *ngIf="isFirstVisible" class="noPrint"
                            style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
                            printTitle="Label" printSectionId="print-section" ngxPrint>
                            print
                        </button>
            </div>
        </div>
    </div>
    <!-- <div style="margin-left: 60%; margin-bottom: 1%" *ngIf="isFirstVisible"> -->
    <!-- <button style="margin-right: 2%" mat-raised-button color="primary" (click)="saveSubscriptionBarcodesDataEntry()">
            Save
        </button> -->
    <!-- <button (click)="closeDialog()" class="btn noPrint">Close</button> -->
    <!-- </div> -->



    <div class="container" id="print-section" *ngIf="isFirstVisible">
        <div class="print-inner">

            <div class="row">
                <div class="col center full-width">{{formattedDate}}</div>
            </div>

            <div class="row">
                <div class="col index table-header-col">क्र.</div>
                <div class="col table-header-col size150">तपशील</div>
                <div class="col table-header-col">विगत</div>
                <div class="col table-header-col size150">प्रति</div>
            </div>
            <div class="row" *ngFor="let data of deleveryModeList; let i = index">
                <div class="col index">{{ i + 1 }}</div>
                <!-- <div class="col size150">वर्गणीदार</div> -->
                <div class="col size150" style="border-bottom: 0px;border-top: 0px;"><span
                        *ngIf="i==middleIndexVarganidar">वर्गणीदार</span>&nbsp;</div>
                <div class="col">
                    {{data.mode_name}}
                </div>
                <div class="col size150">{{data.prati}}</div>

            </div>
            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{varganidarTotal}}</strong></div>
            </div>
            <!-- जादा वर्गणी section -->
            <div class="row" *ngFor="let data of jadaAnkData; let i = index">
                <ng-container *ngIf="i + 1 != lengthOfList">
                    <div class="col index"> {{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;"><span
                            *ngIf="i==middleIndex">जादा वर्गणी</span>&nbsp;</div>
                    <div class="col"> {{data.mode}}</div>
                    <div class="col size150"><input placeholder="Enter value" [(ngModel)]="data.prati"
                            style="height: 40px; width: 120px; padding: 5px; margin-right: 5px;"
                            (input)="jadaVarganiCal()">
                        <span *ngIf="data.checkboxShow" (click)="deleteFromArray(data)"
                            style="background-color: red; color: white; border: 1px solid darkred; padding: 0px 0px; border-radius: 1px; cursor: pointer;">X</span>
                    </div>

                    <!-- <div>
                            <button style="height: 40px; padding: 0 12px;">
                            <mat-icon>add</mat-icon>
                        </button>
                          </div> -->
                </ng-container>

                <ng-container *ngIf="i + 1 == lengthOfList">
                    <div class="col index">{{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;">&nbsp;</div>
                    <div class="col" style="display: flex; align-items: center;">
                        <input #valueInput placeholder="Enter value" [(ngModel)]="newValue"
                            style="height: 40px; width: 250px; padding: 5px; margin-right: 5px;" />
                        <!-- <button style="height: 40px; padding: 0 12px;">
                            <mat-icon>add</mat-icon>
                        </button> -->
                    </div>
                    <div class="col size150" style="display: flex; align-items: center;">
                        <input placeholder="Enter value" [(ngModel)]="newValue1"
                            style="height: 40px; width: 137px; padding: 5px; margin-right: 5px;"
                            (keydown.enter)="setValue()" />
                        <!-- <button style="height: 40px; padding: 0 12px;">
                            <mat-icon>add</mat-icon>
                        </button> -->
                    </div>
                    <!-- <div class="col size150">30000</div> -->
                </ng-container>
            </div>
            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{jadaAnkTotal}}</strong></div>
            </div>
            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण वर्गणीदार</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{jadaAnkTotal+varganidarTotal}}</strong></div>
            </div>
            <!-- अभिकर्ता section -->
            <div class="row" *ngFor="let data of abhikartaData; let i = index">
                <ng-container *ngIf="i + 1 != lengthOfList">
                    <div class="col index"> {{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;"><span
                            *ngIf="i==0">अभिकर्ता</span>&nbsp;</div>
                    <div class="col"> {{data.mode}}</div>
                    <div class="col size150"><input placeholder="Enter value" [(ngModel)]="data.prati"
                            style="height: 40px; width: 120px; padding: 5px; margin-right: 5px;"
                            (input)="abhikartaCal()">
                        <span *ngIf="data.checkboxShow" (click)="deleteFromArray(data)"
                            style="background-color: red; color: white; border: 1px solid darkred; padding: 0px 0px; border-radius: 1px; cursor: pointer;">X</span>
                    </div>

                </ng-container>

                <!-- <ng-container *ngIf="i + 1 == lengthOfList">
                    <div class="col index">{{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;">&nbsp;</div>
                    <div class="col" style="display: flex; align-items: center;">
                        <input #valueInput placeholder="Enter value" [(ngModel)]="newValue"
                            style="height: 40px; width: 300px; padding: 5px; margin-right: 5px;" />
                    </div>
                    <div class="col size150" style="display: flex; align-items: center;">
                        <input placeholder="Enter value" [(ngModel)]="newValue1"
                            style="height: 40px; width: 137px; padding: 5px; margin-right: 5px;"
                            (keydown.enter)="setValue()" />
                    </div>
                </ng-container> -->
            </div>


            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{abhikartaTotal}}</strong></div>
            </div>

            <div class="row" *ngFor="let data of sapremBhet; let i = index">
                <ng-container *ngIf="i + 1 != lengthOfSapremBhet">
                    <div class="col index"> {{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;"><span
                            *ngIf="i==middleIndexSapremBhet">सप्रेम भेट</span>&nbsp;</div>
                    <div class="col"> {{data.mode}}</div>
                    <div class="col size150"><input placeholder="Enter value" [(ngModel)]="data.prati"
                            style="height: 40px; width: 120px; padding: 5px; margin-right: 5px;"
                            (input)="sapremBhetCal()">
                        <span *ngIf="data.checkboxShow" (click)="deleteFromSupremBhetArray(data)"
                            style="background-color: red; color: white; border: 1px solid darkred; padding: 0px 0px; border-radius: 1px; cursor: pointer;">X</span>
                    </div>

                </ng-container>

            </div>

            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{supremBhetTotal}}</strong></div>
            </div>


            <div class="row" *ngFor="let data of karyalayData; let i = index">
                <ng-container *ngIf="i + 1 != lengthOfkaryalay">
                    <div class="col index"> {{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;"><span
                            *ngIf="i==indexOfKaryalay">कार्यालय</span>&nbsp;</div>
                    <div class="col"> {{data.mode}}</div>
                    <div class="col size150"><input placeholder="Enter value" [(ngModel)]="data.prati"
                            style="height: 40px; width: 120px; padding: 5px; margin-right: 5px;"
                            (input)="inputKaralatyTotalCalculate($event,data)">
                        <span *ngIf="data.checkboxShow" (click)="deleteFromKaralayArray(data)"
                            style="background-color: red; color: white; border: 1px solid darkred; padding: 0px 0px; border-radius: 1px; cursor: pointer;">X</span>
                    </div>

                </ng-container>

                <ng-container *ngIf="i + 1 == lengthOfkaryalay">
                    <div class="col index">{{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 0px;border-top: 0px;">&nbsp;</div>
                    <div class="col" style="display: flex; align-items: center;">
                        <input #valueInputKaryalay placeholder="Enter value" [(ngModel)]="karylayInputKey"
                            style="height: 40px; width: 250px; padding: 5px; margin-right: 5px;" />
                    </div>
                    <div class="col size150" style="display: flex; align-items: center;">
                        <input placeholder="Enter value" [(ngModel)]="karylayInputValue"
                            style="height: 40px; width: 137px; padding: 5px; margin-right: 5px;"
                            (keydown.enter)="setValueKaryalay()" />
                    </div>
                </ng-container>
            </div>

            <div class="row">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{karyalayTotal}}</strong></div>
            </div>
            <div class="row">
                <div class="col index">*</div>
                <div class="col size150">कृषी विवेक</div>
                <div class="col">&nbsp;</div>
                <div class="col size150">
                    <input placeholder="Enter value" [(ngModel)]="krushiValue"
                        style="height: 40px; width: 137px; padding: 5px; margin-right: 5px;"
                        (input)="krushiVivekCal()" />
                </div>
            </div>
            <div class="row">
                <div class="col index">*</div>
                <div class="col size150">जादा अंक</div>
                <div class="col">&nbsp;</div>
                <div class="col size150">
                    <input placeholder="Enter value" [(ngModel)]="jadaVarganiNew"
                        style="height: 40px; width: 137px; padding: 5px; margin-right: 5px;"
                        (input)="krushiVivekCal()" />
                </div>
            </div>
            <div class="row"  *ngFor="let data of extraParamList; let i = index">
             <ng-container *ngIf="lengthOfExtra !== 0 && i < (lengthOfExtra - 1)">
                    <div class="col index"> {{ i + 1 }}</div>
                    <div class="col size150">{{data.name}}</div>
                    <div class="col"> {{data.mode}}</div>
                    <div class="col size150">
                        <input placeholder="Enter value" [(ngModel)]="data.prati"
                            style="height: 40px; width: 120px; padding: 5px; margin-right: 5px;"
                            (input)="inputKaralatyTotalCalculate($event,data)">
                        <span *ngIf="data.checkboxShow" (click)="deleteFromExtraArray(data)"
                            style="background-color: red; color: white; border: 1px solid darkred; padding: 0px 0px; border-radius: 1px; cursor: pointer;">X</span>
                    </div>

                </ng-container>
                <ng-container *ngIf="i == lengthOfExtra || i == (lengthOfExtra - 1)">
                    <div class="col index">{{ i + 1 }}</div>
                    <div class="col size150" style="border-bottom: 1px;border-top: 1px;"> 
                        <input #extraValuesManage placeholder="Enter value" [(ngModel)]="extrakeyInput"
                            style="height: 40px; width: 140px; padding: 5px; margin-right: 5px;" /></div>
                    <div class="col" style="display: flex; align-items: center;">
                       <input #extraValuesManage placeholder="Enter value" [(ngModel)]="extrakeyNameInput"
                            style="height: 40px; width: 150px; padding: 5px; margin-right: 5px;" />
                    </div>
                    <div class="col size150" style="display: flex; align-items: center;">
                        <input placeholder="Enter value" [(ngModel)]="extraValueInput"
                            style="height: 40px; width: 137px; padding: 5px;"
                            (keydown.enter)="extraParamForPrintorder()" />
                    </div>
                </ng-container>
            </div>

            <div class="row" style="margin-bottom:10px">
                <div class="col index table-bottom-col">&nbsp;</div>
                <div class="col size150 table-bottom-col">&nbsp;</div>
                <div class="col table-bottom-col"><strong>एकूण</strong></div>
                <div class="col size150 table-bottom-col"> <strong>{{total}}</strong></div>
            </div>
            
        </div>
    </div>

    <div class="container" id="print-section" *ngIf="!isFirstVisible">
        <app-print-order-byfurgation-new [printOrderData]="printOrderData"></app-print-order-byfurgation-new>
    </div>

</div>